/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Use_CasesInputs */

const en_directory_rails_use_cases = /** @type {(inputs: Directory_Rails_Use_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use cases`)
};

const zh_directory_rails_use_cases = /** @type {(inputs: Directory_Rails_Use_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用场景`)
};

/**
* | output |
* | --- |
* | "Use cases" |
*
* @param {Directory_Rails_Use_CasesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_use_cases = /** @type {((inputs?: Directory_Rails_Use_CasesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Use_CasesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_use_cases(inputs)
	return zh_directory_rails_use_cases(inputs)
});
export { directory_rails_use_cases as "directory.rails.use_cases" }